module.exports = __webpack_public_path__ + "media/images/ibu__button__appIos-73e210dd474a807785306c179d75691e.svg";